import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=6d28e360&"
import script from "./OrderManagement.vue?vue&type=script&scoped=true&lang=js&"
export * from "./OrderManagement.vue?vue&type=script&scoped=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports